import { IonActionSheet, IonPopover, IonList, IonButton, IonButtons, IonCard, IonCardHeader, IonCardTitle, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { shareSocialOutline, peopleOutline, imagesOutline, listOutline, close, people, logOutOutline, ellipsisHorizontalOutline, personAddOutline, hammerOutline } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { useState, useRef }  from 'react';
import { Dialog, ConfirmResult } from '@capacitor/dialog';
import { Share } from '@capacitor/share';

import NServer, { UIElement } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";

import '../pages/Main.css'; 

  
const MeTitleContent : React.FC<ContentInterface> = ({ content }) => {
    
    const [menu, openMenu] = useState(false);

    const router = useIonRouter();

    // block the user
    const logout = async () => {
        openMenu(false);

        // ask for block user
        let accept : ConfirmResult = await showConfirm(GetStr(LANGUAGE.TXT_LOGOUT_TITLE), GetStr(LANGUAGE.TXT_ASK_LOGOUT));
        if (accept.value)
        {
            doLogout();
        }
    }

    // block the user
    const doLogout = async () => {
        let v = new Vault();
        await v.read();

        v.account.id = -1;
        v.account.key = "";

        await v.write();

        router.push("/login", "back", "pop");
    }

    // open menu
    const openPopover = () => {
        openMenu(true);
    };

    // block the user
    const blockList = () => {
        openMenu(false);
        router.push("/blocklist", "forward", "push");
    }

    // show the followers
    const showFollower = () => {
        openMenu(false);
        router.push("/followers", "forward", "push");
    }

    // show the user's gallery
    const showGallery = () => {
        openMenu(false);
    }

    // show the profile picture
    const showProfilePic = () => {
        /*
        router.push("/profilepic/" + encodeURIComponent(content.user_avatar), "forward", "push");
        */
        router.push("imgcrop/avt/a/settings/1/1", "forward", "push");
    }

    // share my profile
    const shareProfile = async () => {
        let v = new Vault();
        await v.read();

        let link = "https://nwallet.me/d/social.php?r=ur" + v.account.id;

        await Share.share({
            title: "",
            text: "",
            url: link,
            dialogTitle: "Share Post"
        });

        openMenu(false);
    }
    
    return (
        <div className="me-con-title">
            <IonAvatar className="main-avatar ion-margin-top" onClick={showProfilePic}>
                <img src={content.user_avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
            </IonAvatar>
            <IonCard className="flat-card ion-no-margin ion-text-center margin-n25">
                <IonCardHeader className="margin-25 ion-no-padding ion-padding-top">
                    <IonCardTitle className="name-title"><h1><b>{content.user_name}</b>&nbsp;<img className={ content.user_bm == 1 ? "bluemark" : "ion-hide" } src="/assets/img/bm.png" /></h1></IonCardTitle>
                    <IonText className="ion-text-center" onClick={showFollower}>
                        <IonIcon icon={people} />&nbsp;&nbsp;
                        { GetStr(LANGUAGE.TXT_FOLLOWERS) + content.likes }
                    </IonText>
                    <IonToolbar className="ion-margin-top ion-margin-bottom">
                        <div className="scroll-vert">
                            <IonButton className="main-but profile-but" fill="clear" color="dark" routerLink="/settings">
                                <IonIcon icon={hammerOutline} />&nbsp;&nbsp;
                                { GetStr(LANGUAGE.TXT_PROFILE_EDIT) }
                            </IonButton>
                            <IonButton className="main-but profile-but" fill="clear" color="dark" onClick={openPopover}>
                                <IonIcon icon={ellipsisHorizontalOutline} />&nbsp;
                            </IonButton>
                        </div>
                    </IonToolbar>
                </IonCardHeader>

                { /* menu */ }
                <IonActionSheet
                    isOpen={menu}
                    onDidDismiss={() => openMenu(false)}
                    buttons={
                        [ {
                            text: GetStr(LANGUAGE.TXT_FOLLOWER_LIST),
                            icon: peopleOutline,
                            handler: showFollower
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_SHARE_MY_PROFILE),
                            icon: shareSocialOutline,
                            handler: shareProfile
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_BLOCK_LIST),
                            icon: listOutline,
                            handler: blockList
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_LOGOUT),
                            icon: logOutOutline,
                            handler: logout
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_CANCEL),
                            icon: close,
                            role: 'cancel',
                            handler: () => { openMenu(false) }
                        } ]
                    }
                    >
                </IonActionSheet>
            </IonCard>
        </div>
    );
};
  
export default MeTitleContent;